import Mutations from '../../odata/mutations';

export default { ...new Mutations('scheduledEvent'), ...new Mutations('scheduledEvents') };
